<ion-toolbar>
  <ion-buttons>
    <!-- Heading buttons -->
    <bl-editor-toolbar-button
      ($onClick)="onHeadingClick('h1')"
      ariaLabel="Heading 1"
      title="Heading 1"
      icon="type-h-1"
      [isActive]="formatState.blockType === 'h1'"
    />
    <bl-editor-toolbar-button
      ($onClick)="onHeadingClick('h2')"
      ariaLabel="Heading 2"
      title="Heading 2"
      icon="type-h-2"
      [isActive]="formatState.blockType === 'h2'"
    />
    <bl-editor-toolbar-button
      ($onClick)="onHeadingClick('h3')"
      ariaLabel="Heading 3"
      title="Heading 3"
      icon="type-h-3"
      [isActive]="formatState.blockType === 'h3'"
    />

    <!-- Text formatting buttons -->
    <bl-editor-toolbar-button
      ($onClick)="onBoldClick()"
      ariaLabel="Bold"
      title="Bold"
      icon="type-bold"
      [isActive]="formatState.isBold"
    />
    <bl-editor-toolbar-button
      ($onClick)="onItalicClick()"
      ariaLabel="Italic"
      title="Italic"
      icon="type-italic"
      [isActive]="formatState.isItalic"
    />

    <!--   Backend do not support strikethrough and blockquote so disable them until we figure out what next     -->
    <!--        <bl-editor-toolbar-button-->
    <!--          [size]="buttonSize"-->
    <!--          ($onClick)="onStrikethroughClick()"-->
    <!--          ariaLabel="Strikethrough"-->
    <!--          title="Strike"-->
    <!--          [isActive]="formatState.isStrikethrough"-->
    <!--        >-->
    <!--          <s>S</s>-->
    <!--        </bl-editor-toolbar-button>-->

    <!--        &lt;!&ndash; Block formatting buttons &ndash;&gt;-->
    <!--        <bl-editor-toolbar-button-->
    <!--          [size]="buttonSize"-->
    <!--          ($onClick)="onQuoteClick()"-->
    <!--          ariaLabel="Quote"-->
    <!--          title="Quote"-->
    <!--          [isActive]="formatState.blockType === 'quote'"-->
    <!--        >-->
    <!--          <span class="quote-icon">❝</span>-->
    <!--        </bl-editor-toolbar-button>-->

    <bl-editor-toolbar-button
      ($onClick)="onLinkClick()"
      ariaLabel="Link"
      title="Link"
      icon="link-45-deg"
      [isActive]="formatState.isLink"
    ></bl-editor-toolbar-button>

    <bl-editor-toolbar-button
      ($onClick)="onBulletListClick()"
      ariaLabel="Bullet List"
      title="Bullet List"
      icon="list-ul"
      [isActive]="formatState.blockType === 'bullet'"
    ></bl-editor-toolbar-button>

    <bl-editor-toolbar-button
      ($onClick)="onNumberedListClick()"
      ariaLabel="Numbered List"
      title="Numbered List"
      icon="list-ol"
      [isActive]="formatState.blockType === 'number'"
    ></bl-editor-toolbar-button>
  </ion-buttons>
</ion-toolbar>
